import { createHttpLink } from '@apollo/client'
import { createLink } from 'apollo-absinthe-upload-link'

export const httpLink = name => {
  const uri = `${process.env.REACT_APP_V2_API_URL}/${name}/api`
  // const uri = `https://localhost:4443/${name}/api`
  // const uri = `http://localhost:4040/${name}/api`
  // const uri = `https://dev-api.btime.io/new/${name}/api`
  if (name === 'documents') return createLink({ uri })
  return createHttpLink({ uri })
}
